import { App } from './App.tsx';
import React from 'react';
import ReactDOM from 'react-dom/client';
import Authentication from 'utils/Authentication.tsx';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('index.html has no #root element to mount the app into');
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <Authentication>
      <App />
    </Authentication>
  </React.StrictMode>
);
